import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import api from '../api';

export default function Leaderboard() {
  const { leagueId } = useParams();
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [standings, setStandings] = useState([]);
  const [league, setLeague] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get(`/standings/league/${leagueId}`),
      api.get(`/leagues/${leagueId}`),
    ]).then(([sRes, lRes]) => {
      setStandings(sRes.data);
      setLeague(lRes.data.league);
    }).catch(err => {
      if (err.response?.status === 403) navigate('/');
    }).finally(() => setLoading(false));
  }, [leagueId, navigate]);

  const medals = ['🥇','🥈','🥉'];

  if (loading) return <div className="loading">Loading leaderboard…</div>;

  return (
    <div className="leaderboard-page">
      <div className="flex-between mb-2">
        <div>
          <h1>{league?.name}</h1>
          <p className="text-muted">
            {standings.length} player{standings.length !== 1 ? 's' : ''}
            {league?.is_locked && <> · <span className="tag tag-locked ml-1">🔒 Locked</span></>}
          </p>
        </div>
        <div className="flex-gap">
          {league && !league.is_locked && (
            <button className="btn btn-primary btn-sm" onClick={() => navigate(`/league/${leagueId}/bracket`)}>Edit My Bracket</button>
          )}
          <button className="btn btn-secondary btn-sm" onClick={() => navigate('/')}>← Home</button>
        </div>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <table className="leaderboard-table">
          <thead>
            <tr>
              <th style={{ width: 50 }}>Rank</th>
              <th>Player</th>
              <th style={{ width: 80, textAlign: 'right' }}>Score</th>
              <th style={{ width: 130 }}>Bracket</th>
              <th style={{ width: 130 }}>Last Updated</th>
            </tr>
          </thead>
          <tbody>
            {standings.map((row, i) => (
              <tr key={row.id} className={row.id === user?.id ? 'my-row' : ''}>
                <td className={`rank-num rank-${i + 1}`}>
                  {i < 3 ? medals[i] : `#${i + 1}`}
                </td>
                <td style={{ fontWeight: row.id === user?.id ? 700 : 400 }}>
                  {row.username} {row.id === user?.id && <span style={{ color: 'var(--gold)', fontSize: '0.75rem' }}>(you)</span>}
                </td>
                <td className="score-col" style={{ textAlign: 'right' }}>
                  {row.has_bracket ? row.score : <span className="no-bracket">—</span>}
                </td>
                <td>
                  {row.has_bracket ? (
                    league?.is_locked || row.id === user?.id ? (
                      <button className="btn btn-secondary btn-sm" onClick={() => navigate(`/league/${leagueId}/bracket/${row.id}`)}>
                        View
                      </button>
                    ) : <span className="no-bracket">Locked after start</span>
                  ) : <span className="no-bracket">No bracket</span>}
                </td>
                <td className="text-muted" style={{ fontSize: '0.8rem' }}>
                  {row.last_updated ? new Date(row.last_updated).toLocaleDateString() : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {league?.invite_code && (
        <div className="card mt-3" style={{ textAlign: 'center' }}>
          <div className="text-muted" style={{ marginBottom: '0.3rem' }}>Invite friends with code:</div>
          <div className="invite-code" style={{ fontSize: '1.5rem' }}>{league.invite_code}</div>
        </div>
      )}
    </div>
  );
}
